$(document).ready(function () {
  /**
   *  Two-up Videos
   */
  if ($('.js-video-box').length) {
    $('.js-video-box').each(function () {
      var el = $(this)

      el.on('click', function () {
        $(el).find('.poster').addClass('hide')
        $(el).find('.play-icon').addClass('hide')
        $(el).find('.video').addClass('show')

        if ($(el).find('.video video').length) {
          $(el).find('.video video').get(0).play()
        }
      })
    })
  }
  /**
   *  END Two-up Videos
   */

  /**
   * Register DrawSVGPlugin
   */
  gsap.registerPlugin(ScrollTrigger)
  gsap.registerPlugin(DrawSVGPlugin)

  /**
   * Homepage Animation
   */
  var homepage_desktop_svg = $('#js-homepage-desktop-svg')
  var homepage_desktop_svg_bgs = $('#js-homepage-desktop-svg #Background path')
  var homepage_desktop_svg_bits = $('#js-homepage-desktop-svg #Bits path')
  var bg_stagger = gsap.timeline()
  var bits_stagger = gsap.timeline()
  gsap.set(homepage_desktop_svg_bits, { drawSVG: 0 })

  if (homepage_desktop_svg_bgs.length) {
    bg_stagger.to(homepage_desktop_svg_bgs, 1, {
      fill: '#9EA4B2',
      stagger: 0.05,
    })

    // Draw SVGs
    bits_stagger.to(homepage_desktop_svg_bits, 1.5, {
      drawSVG: '100%',
      ease: 'none',
      stagger: 0.05,
      delay: 1.5,
    })
  }

  /**
   * END - Homepage Animation
   */

  /**
   * Generic Animate SVG BGs around the site
   */
  if ($('.js-animate-bgs').length) {
    gsap.utils.toArray('.js-animate-bgs').forEach(function (elem) {
      var bgs = $(elem).find('path')
      var bgs_stagger = gsap.timeline()
      var color = '#ACDFB5'
      if ($(elem).attr('data-color') != undefined) {
        color = $(elem).attr('data-color')
      }
      ScrollTrigger.create({
        trigger: elem,
        onEnter: function () {
          bgs_stagger.to(bgs, 1.5, {
            fill: color,
            stagger: 0.075,
          })
        },
      })
    })
  }

  /**
   *  Lazy Load Imagaes
   */

  function loadImages() {
    $('[data-img-bg]').each(function () {
      var el = $(this)
      var src = $(this).data('img-bg')
      if (src) {
        var img = new Image()
        img.style.display = 'none'
        img.src = src
        el.css('background-image', 'url(' + src + ')')
        img.onload = function () {
          el.addClass('loaded')
        }
      }
    })
    $('[data-img-src]').each(function () {
      var el = $(this)
      var src = $(this).data('img-src')
      if (src) {
        var img = new Image()
        img.style.display = 'none'
        img.src = src
        el.attr('src', src)
        img.onload = function () {
          el.addClass('loaded')
        }
      }
    })
  }
  loadImages()
  /**
   *  END - Lazy Load Imagaes
   */
})

$(window).load(function () {
  /**
   * Page Scroll
   */

  window.addEventListener('scroll', () => onPageScroll())
  var currScrollPos = window.scrollY
  var nav = $('#js-nav')
  var link_scroll_container = $('#js-link-scroll-container')

  function onPageScroll() {
    var prevScrollPos = currScrollPos
    currScrollPos = window.scrollY

    if (currScrollPos > 144) {
      // add sticky
      nav.addClass('sticky')

      // detect scroll direction, and show or hide
      if (currScrollPos > prevScrollPos) {
        // going down
        if (nav.hasClass('sticky-visible')) {
          nav.addClass('temp-animation-away')
          setTimeout(function () {
            nav.removeClass('temp-animation-away')
          }, 250)
        }

        nav.removeClass('sticky-visible')
        link_scroll_container.removeClass('sticky-visible')
      } else {
        // going up
        nav.addClass('sticky-visible')
        link_scroll_container.addClass('sticky-visible')
      }

      // remove sticky if scroll is less than 80 and scroll is going down.
    } else {
      if (currScrollPos > prevScrollPos) {
        // scrolling down
        nav.removeClass('sticky')
        nav.removeClass('sticky-visible')
        link_scroll_container.removeClass('sticky-visible')
      }

      if (currScrollPos == 0) {
        nav.removeClass('sticky')
        nav.removeClass('sticky-visible')
        link_scroll_container.removeClass('sticky-visible')
      }
    }
  }

  /**
   * END Page Scroll
   */

  /**
   * Start Scroll Trigger
   */

  function animateFrom(elem, direction) {
    direction = direction || 1
    var x = 0,
      y = direction * 100
    if (elem.classList.contains('gs_reveal_fromLeft')) {
      x = -100
      y = 0
    } else if (elem.classList.contains('gs_reveal_fromRight')) {
      x = 100
      y = 0
    }
    elem.style.transform = 'translate(' + x + 'px, ' + y + 'px)'
    elem.style.opacity = '0'
    gsap.fromTo(
      elem,
      { x: x, y: y, autoAlpha: 0 },
      {
        duration: 1.25,
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: 'expo',
        overwrite: 'auto',
      }
    )
  }

  function hide(elem) {
    gsap.set(elem, { autoAlpha: 0 })
  }

  // Slide-in reveals
  gsap.utils.toArray('.gs_reveal').forEach(function (elem) {
    hide(elem) // assure that the element is hidden when scrolled into view

    ScrollTrigger.create({
      trigger: elem,
      onEnter: function () {
        animateFrom(elem)
      },
      onEnterBack: function () {
        // animateFrom(elem, -1)
      },
      onLeaveBack: function () {
        hide(elem)
      }, // assure that the element is hidden when scrolled into view
    })
  })

  // Parallax
  gsap.utils.toArray('.gs_header_parallax').forEach(function (elem) {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: elem,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      })
      .to(elem, { yPercent: 20, ease: 'none' }, 0)
  })

  // 3/4 SVG icons animation
  gsap.utils.toArray('.js-three-fourths-svg').forEach(function (elem) {
    ScrollTrigger.create({
      trigger: elem,
      start: 'bottom 90%',
      onEnter: function () {
        elem.setAttribute('class', 'js-three-fourths-svg active')
      },
    })
  })

  // Logo animation
  gsap.utils.toArray('.js-logo-animate').forEach(function (elem) {
    ScrollTrigger.create({
      trigger: elem,
      start: 'bottom 100%',
      onEnter: function () {
        elem.classList.remove('js-logo-animate')
      },
    })
  })

  gsap.utils.toArray('.js-logo-stroke-animate').forEach(function (elem) {
    ScrollTrigger.create({
      trigger: elem,
      start: 'bottom 100%',
      onEnter: function () {
        elem.classList.add('active')
      },
    })
  })

  // Stats animation
  gsap.utils.toArray('.js-animate-stat').forEach(function (elem) {
    const number = $(elem).find('.number')
    const num = $(elem).find('.number').data('num')
    const obj = { number: 0 }

    ScrollTrigger.create({
      trigger: elem,
      start: 'top bottom',
      onEnter: function () {
        gsap.set(elem, { scale: 0 })
        gsap.fromTo(elem, 2, { scaleX: 0, scaleY: 0 }, { scaleX: 1, scaleY: 1 })
        gsap.fromTo(
          obj,
          3,
          { number: 0 },
          {
            number: num,
            onUpdate: () => {
              number.html(Math.round(obj.number))
            },
          }
        )
      },
      onLeaveBack: function () {
        gsap.set(elem, { scale: 0 })
      },
    })
  })

  /**
   * Window Resize
   */
  var resize_window
  $(window).resize(function () {
    clearTimeout(resize_window)
    resize_window = setTimeout(resizeWindow, 200)
  })
  function resizeWindow() {
    var windowWidth = window.innerWidth

    // Larger than small
    if (windowWidth > 768) {
    }
  }

  $(document).on('scroll', onScroll)

  //Scroll Actuve
  $('.link-scroll a[href^="#"]').on('click', function (e) {
    e.preventDefault()
    $(document).off('scroll')

    $('a').each(function () {
      $(this).removeClass('active')
    })
    $(this).addClass('active')

    var target = this.hash,
      menu = target
    $target = $(target)
    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - 200,
        },
        500,
        'swing',
        function () {
          // window.location.hash = target
          history.pushState(null, null, target)
          $(document).on('scroll', onScroll)
        }
      )
  })

  function onScroll(event) {
    var scrollPos = $(document).scrollTop()
    $('.link-scroll a').each(function () {
      var currLink = $(this)
      var refElement = $(currLink.attr('href'))
      if (refElement.position().top <= scrollPos + 210 && refElement.position().top + refElement.height() > scrollPos - $(window).height()) {
        $('.link-scroll li a').removeClass('active')
        currLink.addClass('active')
      } else {
        currLink.removeClass('active')
      }
    })
  }

  $('.link-view').click(function () {
    $('.link-view').not(this).removeClass('active')
    $(this).toggleClass('active')

    $('.content-block').not($(this).siblings()).slideUp()
    $(this).siblings('.content-block').slideToggle()
  })

  $('.icon-close').click(function () {
    $(this).parents('.content-block').slideUp()
    $(this).parents('.content-block').siblings('.link-view').removeClass('active')
  })

  /**
    Breadcrumbs
  */
  if ($('#js-breadcrumbs').length) {
    $('#js-breadcrumbs').appendTo('#js-breadcrumb-container')
  }

  if ($('.link-scroll').length) {
    $('.link-scroll').appendTo('#js-link-scroll-container')
  }
})
